// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectEntitlementProductDocumentResponseMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_PFIX_PRODUCT_DOCUMENT_RESP)

    this.documents = new Array();
}

DirectEntitlementProductDocumentResponseMessage.prototype = Object.create(DirectMessageBase.prototype)

DirectEntitlementProductDocumentResponseMessage.prototype.GetDocuments = function ()
{
    return this.documents;
}

DirectEntitlementProductDocumentResponseMessage.prototype.AddDocument = function (document)
{
    this.documents.push(document);
};